export function checkPriceIsTrial(price: any) {
    return !!price.freeTrialDuration
}